import {
  DividendInstrumentDateDto,
  DividendInstrumentDto,
  DividendSetDto,
  ProjectDto,
} from '@app/shared/models/contracts/project-dto';
import type { InstrumentDefinitionWithId } from '../store/capital-structure-slice-selectors';

export const addEligibleInstrumentsToAllDividendSets = (
  historicDividendInstruments: Record<string, DividendInstrumentDto>,
  forecastDividendSets: Record<string, DividendSetDto>,
  instrumentDefinitions: Record<string, Omit<InstrumentDefinitionWithId, 'instrumentId'>>,
  projectDraft: ProjectDto,
  historicDividendYears: string[]
) => {
  const eligibleInstrumentIds = Object.entries(instrumentDefinitions)
    .filter(([_, def]) => def.dividendEligible === true)
    .map(([id, _]) => id);

  const caseItemMap = new Map(
    projectDraft.pwermInput.cases.map((caseItem) => [caseItem.dividendSetId, caseItem])
  );

  const updatedForecastSets = { ...forecastDividendSets };
  const updatedHistoricInstruments = { ...historicDividendInstruments };

  Object.entries(updatedForecastSets).forEach(([dividendSetId]) => {
    eligibleInstrumentIds.forEach((instrumentId) => {
      const currentSet = updatedForecastSets[dividendSetId];

      if (!currentSet.instruments[instrumentId]) {
        const caseItem = caseItemMap.get(dividendSetId);

        let forecastYears: string[] = [];

        if (caseItem) {
          forecastYears = caseItem.forecasts.map((forecast) => forecast.forecastYear);
        } else if (projectDraft.opmInput.selectedDividendSetId === dividendSetId) {
          forecastYears = projectDraft.opmInput.perYearInputs.map(
            (perYearInput) => perYearInput.forecastDate
          );
        }

        const dates: Record<string, DividendInstrumentDateDto> = {};
        forecastYears.forEach((year) => {
          dates[year] = { totalDividendValue: null };
        });

        updatedForecastSets[dividendSetId] = {
          ...currentSet,
          instruments: {
            ...currentSet.instruments,
            [instrumentId]: {
              instrumentId: instrumentId,
              dates,
            },
          },
        };
      }
    });
  });

  eligibleInstrumentIds.forEach((instrumentId) => {
    if (!updatedHistoricInstruments[instrumentId]) {
      const dates: Record<string, DividendInstrumentDateDto> = {};
      historicDividendYears.forEach((year) => {
        dates[year] = { totalDividendValue: null };
      });
      updatedHistoricInstruments[instrumentId] = {
        instrumentId: instrumentId,
        dates,
      };
    }
  });

  return { updatedForecastSets, updatedHistoricInstruments };
};
